<h2 mat-dialog-title>{{ data.title ?? 'Create user account' }}</h2>
<mat-dialog-content>
  <div class="entity-form">
    <mat-form-field>
      <mat-label> Email </mat-label>
      <input [formField]="form.Email" matInput type="email" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Full Name </mat-label>
      <input [formField]="form.FullName" matInput />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Role </mat-label>
      <mat-select [formField]="form.Role">
        @for (opt of Roles; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label> State </mat-label>
      <mat-select [formField]="form.State">
        @for (opt of States; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Team </mat-label>
      <mat-select [formField]="form.Team">
        @for (opt of Teams; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Chargeble Hrs. Capacity </mat-label>
      <input [formField]="form.Capacity" step="0.1" matInput type="number" />
    </mat-form-field>

    @if (form.Team().value() === 'po') {
      <mat-form-field>
        <mat-label> Sales Capacity </mat-label>
        <input [formField]="form.SalesCapacity" step="0.1" matInput type="number" />
      </mat-form-field>
    }
    @if (form.Team().value() === 'dev') {
      <mat-form-field>
        <mat-label> CKAN Capacity (ave. SP/month) </mat-label>
        <input [formField]="form.CkanCapacity" step="0.1" matInput type="number" />
      </mat-form-field>

      <mat-form-field>
        <mat-label> Drupal Capacity (ave. SP/month) </mat-label>
        <input [formField]="form.DrupalCapacity" step="0.1" matInput type="number" />
      </mat-form-field>

      <mat-form-field>
        <mat-label> JS Capacity (ave. SP/month) </mat-label>
        <input [formField]="form.JsCapacity" step="0.1" matInput type="number" />
      </mat-form-field>

      <mat-form-field>
        <mat-label> Other Capacity (ave. SP/month) </mat-label>
        <input [formField]="form.OtherCapacity" step="0.1" matInput type="number" />
      </mat-form-field>
    }

    <mat-form-field>
      <mat-label> Jira ID </mat-label>
      <input [formField]="form.JiraId" matInput />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matMiniFab matTooltip="Save user details" (click)="save()" [disabled]="!form().valid() || pending()">
    <mat-icon>save</mat-icon>
  </button>
</mat-dialog-actions>
@if (pending()) {
  <mat-progress-bar mode="indeterminate" />
}
